import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper'
import { createNamespacedHelpers } from 'vuex'
import { InvoiceService, MultiOfferInvoice, OfferService, OfferDetail, OtherCardItemRead } from '~/service/api'

export interface State {
  offers: OfferDetail[],
  clientItemsByOffer: { [offerId: string]: OtherCardItemRead[] }
}

export interface Actions {
  loadOffers: string[]
  loadClientItems: string[]
  create: MultiOfferInvoice
}

export interface Mutations {
  clear: void,
  setOffers: OfferDetail[],
  setClientItemsByOffer: { [offerId: string]: OtherCardItemRead[] }
}

export interface Getters {}

export function state() {
  const state: State = {
    offers: [],
    clientItemsByOffer: {}
  }
  return state
}

export const getters: DefineGetters<Getters, State> = {}

export const actions: DefineActions<Actions, State, Mutations, Getters> = {
  async loadOffers({ commit }, offerIds) {
    const offers = await Promise.all(offerIds.map(id => OfferService.offerRead({ id })))
    commit('setOffers', offers)
  },
  async loadClientItems({ commit }, offerIds) {
    const itemsByOffer: { [offerId: string]: OtherCardItemRead[] } = {}
    await Promise.all(offerIds.map(async(id) => {
      itemsByOffer[id] = await OfferService.offerClientItems({ id })
    }))
    commit('setClientItemsByOffer', itemsByOffer)
  },
  async create({}, data) {
    return await InvoiceService.invoiceCreate({ data })
  }
}

export const mutations: DefineMutations<Mutations, State> = {
  clear(state) {
    state.offers = []
    state.clientItemsByOffer = {}
  },
  setOffers(state, offers) {
    state.offers = offers
  },
  setClientItemsByOffer(state, itemsByOffer) {
    state.clientItemsByOffer = itemsByOffer
  }
}

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} = createNamespacedHelpers<State, Getters, Mutations, Actions>('invoices')

export const invoices = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
